import ApiService from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        listRules: {},
        loading: false,
        globalLoading: false,
        error: {},
    },
    getters: {
        getListRules: (state) => state.listRules,
        getLoading: (state) => state.loading,
        error: (state) => state.error,
    },
    mutations: {
        SET_RULES_LIST(state, listRules) {
            state.listRules = listRules;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_GLOBAL_LOADING(state, val) {
            state.globalLoading = val;
        },
        SET_ERROR(state, val) {
            state.error = val;
        },
    },
    actions: {
        FETCH_LIST_RULES({ commit }, query) {
            commit("SET_LOADING", true);

            return new Promise((resolve) => {
                ApiService.get(`Regole?${query}`)
                    .then((res) => {
                        commit("SET_RULES_LIST", res.data);
                        commit("SET_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => {
                            commit("SET_ERROR", "");
                            commit("SET_LOADING", false);
                        }, 5000);
                    });
            });
        },

        CREATE_RULE({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);

            return new Promise((resolve, reject) => {
                ApiService.post(`Regole`, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        GET_RULE({ commit }, id) {
            return new Promise((resolve) => {
                ApiService.download(`Regole`, id)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },
        UPDATE_RULE({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.update(`Regole`, params.id, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        APPLY_RULE({ commit }, id) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.post(`Regole/apply/${id}`, {})
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
    },
};
